/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  HStack,
  Popover,
  Text,
  PopoverTrigger,
  Box,
  Portal,
  PopoverContent,
  PopoverHeader,
  PopoverCloseButton,
  PopoverBody,
  Stack,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  PopoverFooter,
  Button,
  ButtonGroup,
  useTheme,
} from '@chakra-ui/core';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import isNumber from 'lodash/isNumber';
import { useTranslation } from 'react-i18next';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useGetItemProperty } from '../hooks/useGetItemProperty';
import { useUpdateFormItem } from '../hooks/useUpdateFormItem';

interface MinMaxSelectorProps {
  minValue: number;
  maxValue: number;
  onChange: (value: { min: number; max: number }) => void;
}

const MinMaxSelector: React.FC<MinMaxSelectorProps> = React.memo(
  function MinMaxSelectorComponent({ minValue = 0, maxValue = 10, onChange }: MinMaxSelectorProps) {
    const { t } = useTranslation('hrFormTemplate');
    const theme = useTheme();

    const [currentMin, setCurrentMin] = useState(minValue);
    const [currentMax, setCurrentMax] = useState(maxValue);

    useEffect(() => {
      setCurrentMin(minValue);
    }, [minValue]);

    useEffect(() => {
      setCurrentMax(maxValue);
    }, [maxValue]);

    const hasValuesChanged = useMemo(() => {
      return currentMax !== maxValue || currentMin !== minValue;
    }, [currentMax, currentMin, maxValue, minValue]);

    const handleMinChange = useCallback((_valueAsString: string, valueAsNumber: number) => {
      setCurrentMin(isNaN(valueAsNumber) ? 0 : valueAsNumber);
    }, []);

    const handleMaxChange = useCallback((_valueAsString: string, valueAsNumber: number) => {
      setCurrentMax(isNaN(valueAsNumber) ? 0 : valueAsNumber);
    }, []);

    const handleReset = useCallback(() => {
      setCurrentMin(minValue);
      setCurrentMax(maxValue);
    }, [minValue, maxValue]);

    const handleSaveAndClose = useCallback(
      (onClose: () => void) => {
        onChange({ min: currentMin, max: currentMax });
        onClose();
      },
      [currentMin, currentMax, onChange],
    );

    const handleCancelAndClose = useCallback((onClose: () => void) => {
      setCurrentMin(minValue);
      setCurrentMax(maxValue);
      onClose();
    }, []);

    return (
      <HStack flexShrink={0}>
        <Popover placement="bottom" closeOnBlur={false} isLazy>
          {({ onClose }) => (
            <>
              <PopoverTrigger>
                <Box
                  as="button"
                  type="button"
                  backgroundColor="#E2E8F0"
                  paddingX={theme.space[2]}
                  paddingY={theme.space[1]}
                  borderRadius={theme.radii.md}
                  _hover={{ backgroundColor: '#CBD5E0' }}
                  _active={{ backgroundColor: '#A0AEC0' }}
                >
                  <HStack>
                    <Text fontSize="sm" cursor="pointer">
                      {t('formBuilder.characterLimit.title')} ({minValue} - {maxValue})
                    </Text>
                    <MdKeyboardArrowDown size={20} />
                  </HStack>
                </Box>
              </PopoverTrigger>
              <Portal>
                <PopoverContent boxShadow="lg">
                  <PopoverHeader pt={4} fontWeight="bold" borderBottomWidth="1px">
                    {t('formBuilder.characterLimit.title')}
                  </PopoverHeader>
                  <PopoverCloseButton isDisabled={hasValuesChanged} />
                  <PopoverBody>
                    <Text fontSize="sm" mb={3}>
                      {t('formBuilder.characterLimit.message', { min: currentMin, max: currentMax })}
                    </Text>
                    <HStack spacing={4}>
                      <Stack flex={1} spacing={1}>
                        <Text fontSize="xs" fontWeight="bold" whiteSpace="nowrap">
                          {t('formBuilder.characterLimit.min')}:
                        </Text>
                        <NumberInput
                          allowMouseWheel
                          step={10}
                          value={currentMin}
                          min={0}
                          max={currentMax}
                          onChange={handleMinChange}
                          size="sm"
                        >
                          <NumberInputField borderRadius={theme.radii.md} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </Stack>
                      <Stack flex={1} spacing={1}>
                        <Text fontSize="xs" fontWeight="bold" whiteSpace="nowrap">
                          {t('formBuilder.characterLimit.max')}:
                        </Text>
                        <NumberInput
                          allowMouseWheel
                          step={10}
                          value={currentMax}
                          min={currentMin}
                          max={10000}
                          onChange={handleMaxChange}
                          size="sm"
                        >
                          <NumberInputField borderRadius={theme.radii.md} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </Stack>
                    </HStack>
                  </PopoverBody>
                  <PopoverFooter borderTopWidth="1px" d="flex" alignItems="center" justifyContent="space-between" pt={3} pb={3}>
                    <Button variant="ghost" onClick={handleReset} isDisabled={!hasValuesChanged} size="sm">
                      {t('formBuilder.characterLimit.reset')}
                    </Button>
                    <ButtonGroup size="sm">
                      <Button variant="outline" onClick={() => handleCancelAndClose(onClose)}>
                        {t('formBuilder.characterLimit.cancel')}
                      </Button>
                      <Button colorScheme="blue" onClick={() => handleSaveAndClose(onClose)} isDisabled={!hasValuesChanged}>
                        {t('formBuilder.characterLimit.done')}
                      </Button>
                    </ButtonGroup>
                  </PopoverFooter>
                </PopoverContent>
              </Portal>
            </>
          )}
        </Popover>
      </HStack>
    );
  },
  (p, n) =>
    /* eslint-disable-next-line  */
    p.minValue === n.minValue && p.maxValue === n.maxValue && p.onChange === n.onChange,
);

MinMaxSelector.displayName = 'MinMaxSelector';

interface MinMaxSelectProps {
  fieldId: string;
}

const MinMaxSelect: React.FC<MinMaxSelectProps> = React.memo(
  ({ fieldId }: MinMaxSelectProps) => {
    const minValue = useGetItemProperty(fieldId, 'min');
    const maxValue = useGetItemProperty(fieldId, 'max');
    const isDisabled = useGetItemProperty(fieldId, 'previewPlaceholders?.disableMinMax') ?? false;

    const handleOnChange = useUpdateFormItem();
    const handleMinMaxChange = useCallback(
      (newMinMax: { min: number; max: number }) => {
        handleOnChange(fieldId, newMinMax);
      },
      [handleOnChange],
    );
    if (!isNumber(minValue) || !isNumber(maxValue) || isDisabled) {
      return null;
    }

    return <MinMaxSelector minValue={minValue} maxValue={maxValue} onChange={handleMinMaxChange} />;
  },
  (prevProps, nextProps) => prevProps.fieldId === nextProps.fieldId,
);
MinMaxSelect.displayName = 'MinMaxSelect';

export default MinMaxSelect;
